<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<span>时间：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					:clearable="false"
					type="datetimerange"
					align="right"
					popper-class="filter-time-popper"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm'>
				</el-date-picker>
			</div>
			<div class="order-NO-box">
				<span>客户名称：</span>
				<el-input v-model="customerName" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>客户账号：</span>
				<el-input v-model="tel" placeholder="请输入客户账号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>客户类别：</span>
				<el-select v-model="customercategoryid" class="order-type-select" size='small' filterable multiple collapse-tags>
					<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
				</el-select>
			</div>
			<div class="order-NO-box">
				<span>单据号：</span>
				<el-input v-model="ordernumber" placeholder="请输入单据号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>流水号：</span>
				<el-input v-model="serialnumber" placeholder="请输入流水号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>充值类型：</span>
				<el-select v-model="prepaymenttype" multiple collapse-tags class="order-type-select" clearable size='small'>
					<el-option value="0" label="订单扣除金额"></el-option>
					<el-option value="1" label="微信充值"></el-option>
					<el-option value="2" label="退单返款"></el-option>
					<el-option value="3" label="第三方充值"></el-option>
					<el-option value="4" label="线下打款"></el-option>
					<el-option value="5" label="取消订单返款"></el-option>
					<el-option value="7" label="手工扣减"></el-option>
					<el-option value="8" label="微企付充值"></el-option>
					<el-option value="9" label="B2b门店助手-微信支付"></el-option>
					<el-option value="10" label="B2b门店助手-银行转账"></el-option>
				</el-select>
			</div>
			<div class="order-NO-box">
				<span>店铺名称：</span>
				<el-select v-model="shopid" class="order-type-select" clearable size='small'>
					<el-option v-for="item in shopList" :value="item.id" :label="item.name" :key="item.id"></el-option>
				</el-select>
			</div>
		</div>
		<div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			dateValue: [],
			dateType: '3',
			shopid: '',
			shopList: [],
			customList: [],
			customerName: '',
			customercode: '',
			customersyscoe: '',
			ordernumber: '',
			memo: '',
			tel: '',
			customercategoryid: [],
			prepaymenttype: [],
			serialnumber: '',
			paymentserialnumber: '',
			paymentnumber: '',
			paymentmode: [],
			refundtype: [],
			type: [],
			collapse: true
		}
	},
	created () {
		this.initFilters()
		this.getShopList()
		this.getCategory()
	},
	methods: {
		clearSearch () {
			this.shopid = ''
			this.ordernumber = ''
			this.customerName = ''
			this.serialnumber = ''
			this.tel = ''
			this.prepaymenttype = []
			this.customercategoryid = []
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		initFilters () {
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			}
		},
		getFiltersDate () {
			// return [
			// 	{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]} 00:00:00`, 'op': 'ge', type: 'filtersParams' },
			// 	{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]} 23:59:59`, 'op': 'le', type: 'filtersParams' }
			// ]
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (this.dateValue && this.dateValue.length > 0) {
				filtersParams = [
					{ field: 'createDate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '时间' },
					{ field: 'createDate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '时间' }
				]
			}
			if (this.customerName) {
				let customerNameObj = { 'field': 'name', 'data': this.customerName, 'op': 'cn' }
				filtersParams.push(customerNameObj)
			}
			if (this.tel) {
				let telObj = { 'field': 'tel', 'data': this.tel, 'op': 'cn' }
				filtersParams.push(telObj)
			}
			if (this.shopid) {
				let shopidObj = { 'field': 'shopid', 'data': this.shopid, 'op': 'in' }
				filtersParams.push(shopidObj)
			}
			if (this.customercategoryid) {
				let customercategoryidObj = { 'field': 'customercategoryid', 'data': this.customercategoryid.join(','), 'op': 'in' }
				filtersParams.push(customercategoryidObj)
			}
			if (this.ordernumber) {
				let ordernumberObj = { 'field': 'ordernumber', 'data': this.ordernumber, 'op': 'cn' }
				filtersParams.push(ordernumberObj)
			}
			if (this.prepaymenttype) {
				let prepaymenttypeObj = { 'field': 'prepaymenttype', 'data': this.prepaymenttype.join(','), 'op': 'in' }
				filtersParams.push(prepaymenttypeObj)
			}
			if (this.serialnumber) {
				let serialnumberObj = { 'field': 'serialnumber', 'data': this.serialnumber, 'op': 'cn' }
				filtersParams.push(serialnumberObj)
			}
			return {
				filtersParams,
				cParams
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 100px;
				text-align: right
			}
		}
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			// margin-right: 10px;
			.order-input {
				width:150px
			}
			.order-type-select {
				width:150px
			}
		}
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
<style lang="stylus">
.filter-time-popper {
	.el-button--text {
		display: none
	}
}
</style>
